import '@/i18n/template/api/tokenApi.js'
import axios from 'axios'
import aes from './crypto'
import i18n from '@/i18n'
import { BaseURL, client_id, client_secret, isNotProd } from '@/config'
import apiClient, { setGetAuthDataFun } from './index'
import { getReqId } from '@/util/index'
import { EventTypes, emitEvent } from '@/util/event'
import { MessageBox, Message } from 'element-ui'
import { openMFAModal } from '@/projects/operation/components/LoginMFA.vue'

let authData = null
// 刷新token的请求单例
let refreshTokenReq = null

let authDataRefreshListener = null

function getToken(grantType, data) {
  let options = {
    url: 'sso/oauth/token',
    data: {
      client_id: client_id,
      client_secret: client_secret,
      grant_type: grantType,
      data: data
    },
    showError: false,
    rawData: true
  }
  return apiClient.post(options).then(res => {
    if (res.data?.expires_in) {
      // if (process.env.NODE_ENV === 'development') {
      //   res.data.expires_in = 120
      // }
      res.data.expires_time = Date.now() + res.data.expires_in * 1000
    }
    // 需要MFA
    if (res.code === '10106') {
      return new Promise(resolve => {
        openMFAModal({
          phone: res.data.methodDescList?.[0]?.message || '',
          sessionId: res.data.sessionId || '',
          bizId: res.data.bizId || '',
          method: res.data.nextMethods?.[0] || '',
          onSuccess: mfaRes => {
            const newData = data
            newData.sessionId = mfaRes.sessionId
            newData.bizId = mfaRes.bizId
            newData.jwtToken = mfaRes.transactionToken
            resolve(getToken(grantType, newData))
          },
          onCancel: () => {
            resolve(res)
          },
          onClose: () => {
            resolve(res)
          }
        })
      })
    }
    if (res.code) {
      if (res.code !== '0000') {
        Message.error(res.msg || 'Login Failed')
      }
      return res
    }
    let tData = res.data || res
    // 非 {code:'0000', data: ''}结构， 需要转换一下
    if (tData.access_token) {
      if (tData.expires_in) {
        // if (process.env.NODE_ENV === 'development') {
        //   tData.expires_in = 120
        // }
        tData.expires_time = Date.now() + tData.expires_in * 1000
      }
      return {
        code: '0000',
        data: tData,
        msg: ''
      }
    }
    return { ...res, msg: res.msg || 'Token is null' }
  })
}

export function setAuthData(data) {
  authData = data
}
export async function clearAuthData() {
  if (!authData) return
  let options = {
    url: BaseURL + 'sso/oauth/logout',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + authData.access_token
    },
    data: JSON.stringify({
      reqId: getReqId(),
      data: await aes.encrypt('{}', authData.user_secret)
    })
  }
  authData = null
  return axios(options).then(res => {
    console.log(res.data, '----clear token')
  })
}
export function onAuthDateRefresh(fn) {
  authDataRefreshListener = fn
}

async function refreshToken(refreshToken) {
  let data = {
    grant_type: 'refresh_token',
    client_id: client_id,
    client_secret: client_secret,
    refresh_token: refreshToken
  }
  isNotProd && console.log('----refresh token start, data:', data)
  let options = {
    url: BaseURL + 'sso/oauth/token',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    data: {
      reqId: getReqId(),
      data: await aes.encrypt(JSON.stringify(data), client_secret)
    },
    timeout: 600000
  }

  return axios(options)
    .then(async res => {
      isNotProd && console.log('----refresh token end, res:', res)
      if (res.data && typeof res.data.data === 'string') {
        let dataStr = await aes.decrypt(res.data.data, client_secret)
        isNotProd &&
          console.log('----refresh token end, data decrypt:', dataStr)
        try {
          let data = JSON.parse(dataStr)
          return data
        } catch (e) {
          console.warn('parse json response error', e)
        }
      }
      return false
    })
    .catch(e => {
      return null
    })
}

// 获取授权token信息 且在过期之前刷新token
async function getAndRefreshAuthData() {
  if (authData) {
    // access_token 即将过期 1分钟内
    if (authData.expires_time < Date.now() + 60000) {
      if (!refreshTokenReq) {
        refreshTokenReq = refreshToken(authData.refresh_token)
      }
      let tokenRes = await refreshTokenReq
      tokenRes = tokenRes?.data || tokenRes
      if (tokenRes && tokenRes.access_token) {
        authData = { ...authData, ...tokenRes }
        authData.expires_time = Date.now() + authData.expires_in * 1000
        authDataRefreshListener && authDataRefreshListener(authData)
      }
      refreshTokenReq = null
    }
    return [authData.access_token, authData.user_secret]
  }
  return ['', '']
}

setGetAuthDataFun(getAndRefreshAuthData)

let idleTimer = null
let idleTimeTextTimer = null
let idleMessageBoxShowing = false
let idleLastActiveTime = Date.now()
// 弹窗提示是否需要刷新token 截止时间
let idleMessageDeadLine = 0

export function startIdleTimeOutCheck() {
  document.addEventListener('mousemove', recordIdleTime)
  document.addEventListener('keydown', recordIdleTime)
  document.addEventListener('scroll', recordIdleTime)
  document.addEventListener('touchmove', recordIdleTime)
  idleLastActiveTime = Date.now()
  if (idleTimer) {
    clearInterval(idleTimer)
  }
  idleTimer = setInterval(() => {
    // 自动刷新token
    getAndRefreshAuthData()
    if (!authData) return
    let sessionTime = authData.expires_in * 1000
    let idleTime = Date.now() - idleLastActiveTime
    // 键盘鼠标未操作时间 超过session有效期
    if (idleTime > sessionTime) {
      promptIdleTime()
    }
  }, 5000)
}

function recordIdleTime() {
  idleLastActiveTime = Date.now()
}

function updateIdleTimeoutText() {
  idleTimeTextTimer = setInterval(() => {
    let t = Math.floor((idleMessageDeadLine - Date.now()) / 1000)
    if (t < 0) {
      idleMessageBoxShowing = false
      endIdleTimeOutCheck()
      clearInterval(idleTimeTextTimer)
      MessageBox.close()
      emitEvent(EventTypes.LOGOUT_EVENT, {
        code: '401',
        msg: 'Login Status Expired'
      })
      setTimeout(() => {
        MessageBox.confirm(i18n.t('InactiveSessionExpired'), '', {
          showCancelButton: false,
          type: 'warning'
        })
      }, 500)
    } else {
      let idleTimeoutElement = document.getElementById('token-idle-timeout')
      if (!idleTimeoutElement) return
      idleTimeoutElement.innerHTML = t
    }
  }, 500)
}

function promptIdleTime() {
  if (idleMessageBoxShowing) {
    return
  }
  idleMessageBoxShowing = true
  // 浏览器在后台时，定时器最快也是1分钟执行1次
  const UserIdleTime = 30
  idleMessageDeadLine = Date.now() + UserIdleTime * 1000

  MessageBox.confirm(
    `You have been inactive for a long time. Would you like to continue?<br> (You will be automatically logged out in <span id="token-idle-timeout" style="color: red;">${UserIdleTime}</span> seconds.)`,
    'Warning',
    {
      closeOnClickModal: false,
      dangerouslyUseHTMLString: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Logout',
      showClose: false
    }
  )
    .then(async () => {
      idleMessageBoxShowing = false
      clearInterval(idleTimeTextTimer)
    })
    .catch(e => {
      idleMessageBoxShowing = false
      clearInterval(idleTimeTextTimer)
      emitEvent(EventTypes.LOGOUT_EVENT, {
        code: '401',
        msg: 'Login Status Expired'
      })
    })
  updateIdleTimeoutText()
}
export function endIdleTimeOutCheck() {
  clearTimeout(idleTimer)
  clearInterval(idleTimeTextTimer)
  idleMessageBoxShowing = false
  document.removeEventListener('mousemove', recordIdleTime)
  document.removeEventListener('keydown', recordIdleTime)
  document.removeEventListener('scroll', recordIdleTime)
  document.removeEventListener('touchmove', recordIdleTime)
}

function getBrowserName() {
  let userAgent = navigator.userAgent
  let isOpera = userAgent.indexOf('Opera') > -1
  if (isOpera) {
    return 'Opera'
  }
  if (userAgent.indexOf('Firefox') > -1) {
    return 'FireFox'
  }
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  }
  if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  }
  if (
    userAgent.indexOf('compatible') > -1 &&
    userAgent.indexOf('MSIE') > -1 &&
    !isOpera
  ) {
    return 'IE'
  }
  return 'Unknown Browser'
}

export async function getCustIdPswdSalt(custId) {
  return apiClient.post({
    url: 'common/getLoginPswdSalt',
    data: { custId }
  })
}

export async function getCustIdMPINSalt(custId) {
  return apiClient.post({
    url: 'common/getMpinSalt',
    data: { custId }
  })
}

export async function getCustRprsnIdSalt(custRprsnId) {
  return apiClient.post({
    url: 'common/getLoginPswdSalt',
    data: { custRprsnId }
  })
}
export async function getNotLoginSalt(loinIdNbr) {
  return apiClient.post({
    url: 'sso/oauth/salt',
    data: { loinIdNbr, clientId: 'merchantapp' }
  })
}
export async function getLoginPswdSalt() {
  return apiClient.post({
    url: 'common/app/getLoginPswdSalt',
    data: {}
  })
}
export async function getLoginMpinSalt() {
  return apiClient.post({
    url: 'common/app/getMpinSalt',
    data: {}
  })
}

export async function getTicketPortalNotLoginSalt(loinIdNbr) {
  return apiClient.post({
    url: 'sso/oauth/salt',
    data: { loinIdNbr, clientId: 'app' }
  })
}

export default {
  startIdleTimeOutCheck,
  endIdleTimeOutCheck,
  operationPasswordLogin(data) {
    return getToken('password', {
      loinIdNbr: data.loinIdNbr,
      password: data.password,
      code: data.code,
      uuid: data.uuid
    })
  },
  merchantPasswordLogin(data) {
    let deviceNm = `Web (${getBrowserName()})`
    return getToken('password', {
      loinIdNbr: data.loinIdNbr,
      password: data.password,
      loinTpCd: '01',
      code: data.code,
      uuid: data.uuid,
      deviceNm: deviceNm,
      salt: data.salt,
      nonce: data.nonce
    })
  },
  merchantSmsLogin(data) {
    let deviceNm = `Web (${getBrowserName()})`
    return getToken('mobile', {
      ...data,
      authTrgtTpCd: '03',
      apptype: 'merchant',
      deviceNm: deviceNm
    })
  },
  merchantQrcodeLogin(qrcode) {
    let deviceNm = `Web (${getBrowserName()})`
    return getToken('qrcode', {
      qrcode: qrcode, // 二维码uuid
      deviceNm: deviceNm
    })
  },
  tellerLoginByToken({ staffId, data }) {
    return getToken('exchange', {
      staffId: staffId,
      data: data // teller 登录的密钥加密数据
    })
  },
  ticketPortalPasswordLogin(data) {
    let deviceNm = `Web (${getBrowserName()})`
    return getToken('password', {
      loinIdNbr: data.loinIdNbr,
      password: data.password,
      loinTpCd: '01',
      apptype: 'customer',
      code: data.code,
      uuid: data.uuid,
      deviceNm: deviceNm,
      salt: data.salt,
      nonce: data.nonce
    })
  },
  ticketPortalSmsLogin(data) {
    let deviceNm = `Web (${getBrowserName()})`
    return getToken('mobile', {
      ...data,
      authTrgtTpCd: '03',
      apptype: 'customer',
      deviceNm: deviceNm
    })
  }
}
